import { UICommandKeyboardInput } from "../../../library-js/dom-ui/commands/UICommandKeyboardInput";
import { isClassOf } from "../../../library-js/tools/TypeUtilities";
import { NodeGraphEdge } from "../model/NodeGraphEdge";
import { NodeGraphNode } from "../model/NodeGraphNode";
import { NGCommand } from "./NGCommand";
import { NGCommandContext } from "./NGCommandContext";
import { NGCommandManager } from "./NGCommandManager";

export class Delete extends NGCommand
{
  _initialize()
  {
    let input = new UICommandKeyboardInput();
    input.key = "Delete";
    this.keyboardInputs.push( input );
  }

  execute( context: NGCommandContext ) 
  {
    let ng = this._manager._nodeGraph;

    let nodes:NodeGraphNode[] = [];

    for ( let id of this.selection.all )
    {
      let ref = ng.get( id );

      if ( isClassOf( ref, NodeGraphEdge ) )
      {
        ng.deleteEdge( ref as NodeGraphEdge );
      }

      if ( isClassOf( ref, NodeGraphNode ) )
      {
        nodes.push( ref as NodeGraphNode );
      }

    }

    nodes.forEach(
      n=> 
      {
        ng.deleteNode( n );
      }
    )

    ng._ui.updateEdges();
  }
}